import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Card, PageHeader, Spinner } from "../../components/dashboard/DashboardShell";
import OrdersTable from "../../components/dashboard/OrdersTable";
import { Button } from "../../components/ui/button";

const TABS = [
  { id: "", label: "Semua" },
  { id: "menunggu_bayar", label: "Menunggu Bayar", roles: ["pengguna", "admin"] },
  { id: "menunggu_konfirmasi", label: "Menunggu Konfirmasi" },
  { id: "dijadwalkan", label: "Dijadwalkan" },
  { id: "sedang_inspeksi,menunggu_review", label: "Berlangsung" },
  { id: "selesai", label: "Selesai" },
  { id: "dibatalkan", label: "Dibatalkan" },
];

export default function OrdersPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("");
  const { data, isLoading } = useQuery({ queryKey: ["orders", tab || "all"], queryFn: () => api.get("/orders", { params: tab ? { status: tab } : {} }).then((r) => r.data) });
  const titles = { pengguna: ["Pesanan Saya", "Pantau status setiap pesanan inspeksi Anda."], inspector: ["Pesanan Masuk", "Konfirmasi pesanan baru dan kelola pesanan berjalan."], admin: ["Manajemen Pesanan", "Semua pesanan di platform Inspecar."] };
  const [title, subtitle] = titles[user.role];
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle}
        action={user.role === "pengguna" && (
          <Button onClick={() => navigate("/pengguna/cari")} data-testid="new-order-btn" className="bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl h-10 px-4 text-sm">
            <Plus size={16} className="mr-1.5" /> Pesan Inspeksi
          </Button>
        )} />
      <div className="flex gap-2 overflow-x-auto pb-3 -mx-1 px-1" data-testid="orders-tabs">
        {TABS.filter((t) => !t.roles || t.roles.includes(user.role)).map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`orders-tab-${t.id || "all"}`}
            className={`whitespace-nowrap text-xs font-bold rounded-full px-4 py-2 border transition-colors ${tab === t.id ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-500 border-slate-200 hover:border-blue-300"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <Card className="mt-2">
        {isLoading ? <Spinner /> : <OrdersTable orders={data} />}
      </Card>
    </div>
  );
}
